module.exports = __webpack_public_path__ + "img/logo@3x.3778b4dd.png";